<div class="top-bar">
    <mat-expansion-panel hideToggle (keydown.Space)="espai($event)">
        <mat-expansion-panel-header (keydown.Space)="espai($event)">
            <mat-panel-title (keydown.Space)="espai($event)">
                <div class="esquerra">
                    <div *ngIf="value!=null && value.address!=null" class="address boleta"
                        [ngStyle]="value.address.style">
                        <div class="inner-boleta">
                            {{value.address.addressKey}}
                        </div>
                    </div>
                    <div *ngIf="value!=null && value.accessControl!=null" class="ambit boleta"
                        [ngStyle]="value.accessControl.style">
                        <div class="inner-boleta">
                            {{value.accessControl.accessControlKey}}
                        </div>
                    </div>
                </div>
                <div class="centre block-searchbox" *ngIf="filter!=null">
                    <input class="searchbox" placeholder="{{'SEARCH'| translate}}" type=text
                        [(ngModel)]="filter.searchText">
                    <div class="button reload"><i aria-hidden="true" class="fa fa-refresh"
                            (click)="reloadClick($event)"></i>
                    </div>
                    <div class="chip active header" *ngIf="filter?.selectedPeriodId">
                        {{filter.selectedPeriodId+".CAPTION" |
                        translate}}</div>
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-expansion-panel-body>
            <shared-address-accesscontrol-selector-component [(value)]="addressAccessControl"
                (changeValues)="onChangeAddressAccessControl($event)">
            </shared-address-accesscontrol-selector-component>
            <options *ngIf="filter" class="slim small nopadding" [optionstrip]="filter.periodFilter"
                (clickOption)="filterChanged($event)"></options>
        </mat-expansion-panel-body>
    </mat-expansion-panel>
</div>
<div class="columns">
    <div class="left-column" [class.left-open]="columnLeftView === 1" [class.left-full]="columnLeftView === 2">
        <shared-forklift-left [value]="value" [columnLeftView]="columnLeftView" [openGateIds]="openGateIds"
            [selectedGateId]="selectedGateId" [selectedRoute]="selectedRoute" [searchText]="filter?.searchText"
            (clickGateOption)="onClickGateOption($event)" (clickRoute)="onClickRoute($event)"
            (dblClickRoute)="onDblClickRoute($event)" (changeOpenGateIds)="onChangeOpenGateIds($event)"
            (refresh)="onLeftRefresh()">
        </shared-forklift-left>
    </div>
    <button class="toggle-btn" (click)="onColumnLeftViewChange((columnLeftView + 1) % 3)">
        <mat-icon>{{ columnLeftView === 0 ? 'chevron_left' : columnLeftView === 1 ? 'open_in_full' : 'chevron_right'
            }}</mat-icon>
    </button>
    <div class="right-column" [class.actions-only]="columnLeftView === 2">
        <shared-forklift-right [selectedPhaseId]="selectedPhaseId"
            [accessControlId]="filter?.accessControlId" [actionsWidth]="actionsWidth"
            [showDetail]="columnLeftView !== 2" (phaseChanged)="onPhaseChanged($event)"
            (refresh)="onRightRefresh()">
        </shared-forklift-right>
    </div>
</div>